var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmail = function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.25 20.86q-.6 0-1.05-.45t-.45-1.05v-13q0-.6.45-1.05t1.05-.45h17q.6 0 1.05.45t.45 1.05v13q0 .6-.45 1.05t-1.05.45zm8.5-7.55-8.5-5.58v11.63h17V7.73zm0-1.5 8.4-5.45H4.37zm-8.5-4.08V6.36v13z"
  })));
};
export default SvgIconEmail;